export const UNIVERSITIES: any = {
	['UNIR_ES']: {
		name: 'UNIR',
		LogoImage: 'unir-logo.svg',
		filterInvert: true,
		host: 'guia.unir.net'
	},
	['HUMANIUM']: {
		name: 'UNIPRO',
		LogoImage: 'unipro-logo.png',
		filterInvert: true,
		host: 'guia.universidadunipro.com'
	},
	['VILLANUEVA']: {
		name: 'Villanueva',
		LogoImage: 'villanueva-logo.svg',
		filterInvert: true,
		host: 'guia.villanueva.edu'
	}
};
